import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const scoreColor = (score) => {
  if (score === null || score === undefined) return { text: "text-muted-foreground", bg: "bg-muted", hex: "#A1A1AA", bghex: "#F4F4F5", label: "—" };
  if (score >= 60) return { text: "text-score-good", bg: "bg-score-goodbg", hex: "#059669", bghex: "#D1FAE5", label: "Güçlü" };
  if (score >= 30) return { text: "text-score-medium", bg: "bg-score-mediumbg", hex: "#D97706", bghex: "#FEF3C7", label: "Orta" };
  return { text: "text-score-poor", bg: "bg-score-poorbg", hex: "#E11D48", bghex: "#FFE4E6", label: "Zayıf" };
};

export const PROVIDER_META = {
  openai: { label: "ChatGPT", hex: "#10A37F" },
  perplexity: { label: "Perplexity", hex: "#0EA5C4" },
  gemini: { label: "Gemini", hex: "#8B5CF6" },
};

export const INTENT_LABELS = {
  general: "Genel",
  comparison: "Karşılaştırma",
  price: "Fiyat",
  trust: "Güven",
  procedure: "İşlem",
};
